module.exports = ":host {\n  display: block;\n  height: 100vh;\n  background-color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/alg-billing-frequency/alg-billing-frequency.component.scss
// module id = ./src/app/pages/alg-billing-frequency/alg-billing-frequency.component.scss
// module chunks = main